import React, { FunctionComponent } from 'react';

import { Divider, Stack, Typography } from '@mui/material';
import {
  DESCTOP_TWO_CHANGE,
  WINDOW_H,
  WINDOW_V,
} from '../../constant/constants';

interface Props {
  image1: any;
  image2: any;
  image5: any;
  title: string;
  text: string;
  widthTitle: string;
  widthText: string;
  windowState: number;
  isChange: boolean;
}

export const LendingDivtemTextWithImage2: FunctionComponent<Props> = ({
  image1,
  image2,
  image5,
  title,
  text,
  widthTitle,
  widthText,
  windowState,
  isChange,
}) => (
  <Stack
    width="100%"
    paddingLeft={windowState === WINDOW_H ? '300px' : undefined}
    alignItems={windowState === WINDOW_H ? 'flex-end' : undefined}
  >
    {windowState === WINDOW_V && (
      <Stack width="100%" paddingTop="50px" spacing={1}>
        <Stack width="100%" direction="row" spacing={1}>
          <img
            alt=""
            width="32px"
            height="32px"
            style={{
              paddingLeft: '20px',
            }}
            src={image1}
          />
          <Stack paddingLeft="20px" width="100%" spacing={1}>
            <Typography
              width={widthTitle}
              fontWeight={700}
              fontFamily="Comfortaa"
              fontSize="16px"
              letterSpacing="0.3px"
              textAlign="left"
              color="#000000"
              component="text"
            >
              {title}
            </Typography>
            <Divider
              sx={{
                width: '100%',
                border: '1px solid rgba(0, 0, 0, 1)',
                borderRadius: '3px',
              }}
              orientation="horizontal"
              flexItem
            />
            <Typography
              width={widthText}
              fontWeight={400}
              fontFamily="Roboto"
              lineHeight="20px"
              fontSize="12px"
              letterSpacing="0.3px"
              textAlign="left"
              color="#000000"
              component="text"
            >
              {text}
            </Typography>
          </Stack>
        </Stack>
        <Stack width="100%" alignItems="center" paddingTop="20px" spacing={1}>
          <img alt="" width="313px" src={image2} />
        </Stack>
      </Stack>
    )}
    {windowState === WINDOW_H && (
      <Stack width="100%" direction="row" paddingTop="50px" spacing={1}>
        <Stack width="250px" direction="row" spacing={1}>
          <img
            alt=""
            width="32px"
            height="32px"
            style={{
              paddingLeft: '20px',
            }}
            src={image1}
          />
          <Stack paddingLeft="20px" width="100%" spacing={1}>
            <Typography
              width={widthTitle}
              fontWeight={700}
              fontFamily="Comfortaa"
              fontSize="16px"
              letterSpacing="0.3px"
              textAlign="left"
              color="#000000"
              component="text"
            >
              {title}
            </Typography>
            <Divider
              sx={{
                width: '250px',
                border: '1px solid rgba(0, 0, 0, 1)',
                borderRadius: '3px',
              }}
              orientation="horizontal"
              flexItem
            />
            <Typography
              width={widthText}
              fontWeight={400}
              fontFamily="Roboto"
              lineHeight="24px"
              fontSize="14px"
              letterSpacing="0.3px"
              textAlign="left"
              color="#000000"
              component="text"
            >
              {text}
            </Typography>
          </Stack>
        </Stack>
        <Stack
          width="100%"
          paddingLeft="20px"
          alignItems="flex-start"
          direction="row"
          spacing={1}
        >
          <img alt="" width="313px" src={!isChange ? image2 : image5} />
          {window.innerWidth > DESCTOP_TWO_CHANGE && (
            <img alt="" width="313px" src={!isChange ? image5 : image2} />
          )}
        </Stack>
      </Stack>
    )}
  </Stack>
);
